/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const nexconsole = $root.nexconsole = (() => {

    /**
     * Namespace nexconsole.
     * @exports nexconsole
     * @namespace
     */
    const nexconsole = {};

    nexconsole.ServerMessage = (function() {

        /**
         * Properties of a ServerMessage.
         * @memberof nexconsole
         * @interface IServerMessage
         * @property {nexconsole.IControllerJoined|null} [controllerJoined] ServerMessage controllerJoined
         * @property {nexconsole.IControllerLeft|null} [controllerLeft] ServerMessage controllerLeft
         * @property {nexconsole.IControllerTypeAssigned|null} [controllerTypeAssigned] ServerMessage controllerTypeAssigned
         */

        /**
         * Constructs a new ServerMessage.
         * @memberof nexconsole
         * @classdesc Represents a ServerMessage.
         * @implements IServerMessage
         * @constructor
         * @param {nexconsole.IServerMessage=} [properties] Properties to set
         */
        function ServerMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServerMessage controllerJoined.
         * @member {nexconsole.IControllerJoined|null|undefined} controllerJoined
         * @memberof nexconsole.ServerMessage
         * @instance
         */
        ServerMessage.prototype.controllerJoined = null;

        /**
         * ServerMessage controllerLeft.
         * @member {nexconsole.IControllerLeft|null|undefined} controllerLeft
         * @memberof nexconsole.ServerMessage
         * @instance
         */
        ServerMessage.prototype.controllerLeft = null;

        /**
         * ServerMessage controllerTypeAssigned.
         * @member {nexconsole.IControllerTypeAssigned|null|undefined} controllerTypeAssigned
         * @memberof nexconsole.ServerMessage
         * @instance
         */
        ServerMessage.prototype.controllerTypeAssigned = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ServerMessage serverEvent.
         * @member {"controllerJoined"|"controllerLeft"|"controllerTypeAssigned"|undefined} serverEvent
         * @memberof nexconsole.ServerMessage
         * @instance
         */
        Object.defineProperty(ServerMessage.prototype, "serverEvent", {
            get: $util.oneOfGetter($oneOfFields = ["controllerJoined", "controllerLeft", "controllerTypeAssigned"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ServerMessage instance using the specified properties.
         * @function create
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {nexconsole.IServerMessage=} [properties] Properties to set
         * @returns {nexconsole.ServerMessage} ServerMessage instance
         */
        ServerMessage.create = function create(properties) {
            return new ServerMessage(properties);
        };

        /**
         * Encodes the specified ServerMessage message. Does not implicitly {@link nexconsole.ServerMessage.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {nexconsole.IServerMessage} message ServerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerJoined != null && Object.hasOwnProperty.call(message, "controllerJoined"))
                $root.nexconsole.ControllerJoined.encode(message.controllerJoined, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.controllerLeft != null && Object.hasOwnProperty.call(message, "controllerLeft"))
                $root.nexconsole.ControllerLeft.encode(message.controllerLeft, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.controllerTypeAssigned != null && Object.hasOwnProperty.call(message, "controllerTypeAssigned"))
                $root.nexconsole.ControllerTypeAssigned.encode(message.controllerTypeAssigned, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ServerMessage message, length delimited. Does not implicitly {@link nexconsole.ServerMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {nexconsole.IServerMessage} message ServerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ServerMessage message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.ServerMessage} ServerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.ServerMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerJoined = $root.nexconsole.ControllerJoined.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.controllerLeft = $root.nexconsole.ControllerLeft.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.controllerTypeAssigned = $root.nexconsole.ControllerTypeAssigned.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ServerMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.ServerMessage} ServerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ServerMessage message.
         * @function verify
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ServerMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.controllerJoined != null && message.hasOwnProperty("controllerJoined")) {
                properties.serverEvent = 1;
                {
                    let error = $root.nexconsole.ControllerJoined.verify(message.controllerJoined);
                    if (error)
                        return "controllerJoined." + error;
                }
            }
            if (message.controllerLeft != null && message.hasOwnProperty("controllerLeft")) {
                if (properties.serverEvent === 1)
                    return "serverEvent: multiple values";
                properties.serverEvent = 1;
                {
                    let error = $root.nexconsole.ControllerLeft.verify(message.controllerLeft);
                    if (error)
                        return "controllerLeft." + error;
                }
            }
            if (message.controllerTypeAssigned != null && message.hasOwnProperty("controllerTypeAssigned")) {
                if (properties.serverEvent === 1)
                    return "serverEvent: multiple values";
                properties.serverEvent = 1;
                {
                    let error = $root.nexconsole.ControllerTypeAssigned.verify(message.controllerTypeAssigned);
                    if (error)
                        return "controllerTypeAssigned." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ServerMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.ServerMessage} ServerMessage
         */
        ServerMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.ServerMessage)
                return object;
            let message = new $root.nexconsole.ServerMessage();
            if (object.controllerJoined != null) {
                if (typeof object.controllerJoined !== "object")
                    throw TypeError(".nexconsole.ServerMessage.controllerJoined: object expected");
                message.controllerJoined = $root.nexconsole.ControllerJoined.fromObject(object.controllerJoined);
            }
            if (object.controllerLeft != null) {
                if (typeof object.controllerLeft !== "object")
                    throw TypeError(".nexconsole.ServerMessage.controllerLeft: object expected");
                message.controllerLeft = $root.nexconsole.ControllerLeft.fromObject(object.controllerLeft);
            }
            if (object.controllerTypeAssigned != null) {
                if (typeof object.controllerTypeAssigned !== "object")
                    throw TypeError(".nexconsole.ServerMessage.controllerTypeAssigned: object expected");
                message.controllerTypeAssigned = $root.nexconsole.ControllerTypeAssigned.fromObject(object.controllerTypeAssigned);
            }
            return message;
        };

        /**
         * Creates a plain object from a ServerMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {nexconsole.ServerMessage} message ServerMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.controllerJoined != null && message.hasOwnProperty("controllerJoined")) {
                object.controllerJoined = $root.nexconsole.ControllerJoined.toObject(message.controllerJoined, options);
                if (options.oneofs)
                    object.serverEvent = "controllerJoined";
            }
            if (message.controllerLeft != null && message.hasOwnProperty("controllerLeft")) {
                object.controllerLeft = $root.nexconsole.ControllerLeft.toObject(message.controllerLeft, options);
                if (options.oneofs)
                    object.serverEvent = "controllerLeft";
            }
            if (message.controllerTypeAssigned != null && message.hasOwnProperty("controllerTypeAssigned")) {
                object.controllerTypeAssigned = $root.nexconsole.ControllerTypeAssigned.toObject(message.controllerTypeAssigned, options);
                if (options.oneofs)
                    object.serverEvent = "controllerTypeAssigned";
            }
            return object;
        };

        /**
         * Converts this ServerMessage to JSON.
         * @function toJSON
         * @memberof nexconsole.ServerMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServerMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ServerMessage
         * @function getTypeUrl
         * @memberof nexconsole.ServerMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ServerMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.ServerMessage";
        };

        return ServerMessage;
    })();

    nexconsole.ControllerJoined = (function() {

        /**
         * Properties of a ControllerJoined.
         * @memberof nexconsole
         * @interface IControllerJoined
         * @property {string|null} [controllerId] ControllerJoined controllerId
         * @property {string|null} [controllerName] ControllerJoined controllerName
         * @property {number|Long|null} [joinedAtMs] ControllerJoined joinedAtMs
         */

        /**
         * Constructs a new ControllerJoined.
         * @memberof nexconsole
         * @classdesc Represents a ControllerJoined.
         * @implements IControllerJoined
         * @constructor
         * @param {nexconsole.IControllerJoined=} [properties] Properties to set
         */
        function ControllerJoined(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ControllerJoined controllerId.
         * @member {string} controllerId
         * @memberof nexconsole.ControllerJoined
         * @instance
         */
        ControllerJoined.prototype.controllerId = "";

        /**
         * ControllerJoined controllerName.
         * @member {string} controllerName
         * @memberof nexconsole.ControllerJoined
         * @instance
         */
        ControllerJoined.prototype.controllerName = "";

        /**
         * ControllerJoined joinedAtMs.
         * @member {number|Long} joinedAtMs
         * @memberof nexconsole.ControllerJoined
         * @instance
         */
        ControllerJoined.prototype.joinedAtMs = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ControllerJoined instance using the specified properties.
         * @function create
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {nexconsole.IControllerJoined=} [properties] Properties to set
         * @returns {nexconsole.ControllerJoined} ControllerJoined instance
         */
        ControllerJoined.create = function create(properties) {
            return new ControllerJoined(properties);
        };

        /**
         * Encodes the specified ControllerJoined message. Does not implicitly {@link nexconsole.ControllerJoined.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {nexconsole.IControllerJoined} message ControllerJoined message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerJoined.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerId != null && Object.hasOwnProperty.call(message, "controllerId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.controllerId);
            if (message.controllerName != null && Object.hasOwnProperty.call(message, "controllerName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.controllerName);
            if (message.joinedAtMs != null && Object.hasOwnProperty.call(message, "joinedAtMs"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.joinedAtMs);
            return writer;
        };

        /**
         * Encodes the specified ControllerJoined message, length delimited. Does not implicitly {@link nexconsole.ControllerJoined.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {nexconsole.IControllerJoined} message ControllerJoined message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerJoined.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ControllerJoined message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.ControllerJoined} ControllerJoined
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerJoined.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.ControllerJoined();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerId = reader.string();
                        break;
                    }
                case 2: {
                        message.controllerName = reader.string();
                        break;
                    }
                case 3: {
                        message.joinedAtMs = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ControllerJoined message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.ControllerJoined} ControllerJoined
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerJoined.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ControllerJoined message.
         * @function verify
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ControllerJoined.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                if (!$util.isString(message.controllerId))
                    return "controllerId: string expected";
            if (message.controllerName != null && message.hasOwnProperty("controllerName"))
                if (!$util.isString(message.controllerName))
                    return "controllerName: string expected";
            if (message.joinedAtMs != null && message.hasOwnProperty("joinedAtMs"))
                if (!$util.isInteger(message.joinedAtMs) && !(message.joinedAtMs && $util.isInteger(message.joinedAtMs.low) && $util.isInteger(message.joinedAtMs.high)))
                    return "joinedAtMs: integer|Long expected";
            return null;
        };

        /**
         * Creates a ControllerJoined message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.ControllerJoined} ControllerJoined
         */
        ControllerJoined.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.ControllerJoined)
                return object;
            let message = new $root.nexconsole.ControllerJoined();
            if (object.controllerId != null)
                message.controllerId = String(object.controllerId);
            if (object.controllerName != null)
                message.controllerName = String(object.controllerName);
            if (object.joinedAtMs != null)
                if ($util.Long)
                    (message.joinedAtMs = $util.Long.fromValue(object.joinedAtMs)).unsigned = true;
                else if (typeof object.joinedAtMs === "string")
                    message.joinedAtMs = parseInt(object.joinedAtMs, 10);
                else if (typeof object.joinedAtMs === "number")
                    message.joinedAtMs = object.joinedAtMs;
                else if (typeof object.joinedAtMs === "object")
                    message.joinedAtMs = new $util.LongBits(object.joinedAtMs.low >>> 0, object.joinedAtMs.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ControllerJoined message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {nexconsole.ControllerJoined} message ControllerJoined
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ControllerJoined.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.controllerId = "";
                object.controllerName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.joinedAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.joinedAtMs = options.longs === String ? "0" : 0;
            }
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                object.controllerId = message.controllerId;
            if (message.controllerName != null && message.hasOwnProperty("controllerName"))
                object.controllerName = message.controllerName;
            if (message.joinedAtMs != null && message.hasOwnProperty("joinedAtMs"))
                if (typeof message.joinedAtMs === "number")
                    object.joinedAtMs = options.longs === String ? String(message.joinedAtMs) : message.joinedAtMs;
                else
                    object.joinedAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.joinedAtMs) : options.longs === Number ? new $util.LongBits(message.joinedAtMs.low >>> 0, message.joinedAtMs.high >>> 0).toNumber(true) : message.joinedAtMs;
            return object;
        };

        /**
         * Converts this ControllerJoined to JSON.
         * @function toJSON
         * @memberof nexconsole.ControllerJoined
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ControllerJoined.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ControllerJoined
         * @function getTypeUrl
         * @memberof nexconsole.ControllerJoined
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ControllerJoined.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.ControllerJoined";
        };

        return ControllerJoined;
    })();

    nexconsole.ControllerLeft = (function() {

        /**
         * Properties of a ControllerLeft.
         * @memberof nexconsole
         * @interface IControllerLeft
         * @property {string|null} [controllerId] ControllerLeft controllerId
         * @property {number|Long|null} [leftAtMs] ControllerLeft leftAtMs
         */

        /**
         * Constructs a new ControllerLeft.
         * @memberof nexconsole
         * @classdesc Represents a ControllerLeft.
         * @implements IControllerLeft
         * @constructor
         * @param {nexconsole.IControllerLeft=} [properties] Properties to set
         */
        function ControllerLeft(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ControllerLeft controllerId.
         * @member {string} controllerId
         * @memberof nexconsole.ControllerLeft
         * @instance
         */
        ControllerLeft.prototype.controllerId = "";

        /**
         * ControllerLeft leftAtMs.
         * @member {number|Long} leftAtMs
         * @memberof nexconsole.ControllerLeft
         * @instance
         */
        ControllerLeft.prototype.leftAtMs = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ControllerLeft instance using the specified properties.
         * @function create
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {nexconsole.IControllerLeft=} [properties] Properties to set
         * @returns {nexconsole.ControllerLeft} ControllerLeft instance
         */
        ControllerLeft.create = function create(properties) {
            return new ControllerLeft(properties);
        };

        /**
         * Encodes the specified ControllerLeft message. Does not implicitly {@link nexconsole.ControllerLeft.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {nexconsole.IControllerLeft} message ControllerLeft message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerLeft.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerId != null && Object.hasOwnProperty.call(message, "controllerId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.controllerId);
            if (message.leftAtMs != null && Object.hasOwnProperty.call(message, "leftAtMs"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.leftAtMs);
            return writer;
        };

        /**
         * Encodes the specified ControllerLeft message, length delimited. Does not implicitly {@link nexconsole.ControllerLeft.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {nexconsole.IControllerLeft} message ControllerLeft message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerLeft.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ControllerLeft message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.ControllerLeft} ControllerLeft
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerLeft.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.ControllerLeft();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerId = reader.string();
                        break;
                    }
                case 2: {
                        message.leftAtMs = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ControllerLeft message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.ControllerLeft} ControllerLeft
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerLeft.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ControllerLeft message.
         * @function verify
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ControllerLeft.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                if (!$util.isString(message.controllerId))
                    return "controllerId: string expected";
            if (message.leftAtMs != null && message.hasOwnProperty("leftAtMs"))
                if (!$util.isInteger(message.leftAtMs) && !(message.leftAtMs && $util.isInteger(message.leftAtMs.low) && $util.isInteger(message.leftAtMs.high)))
                    return "leftAtMs: integer|Long expected";
            return null;
        };

        /**
         * Creates a ControllerLeft message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.ControllerLeft} ControllerLeft
         */
        ControllerLeft.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.ControllerLeft)
                return object;
            let message = new $root.nexconsole.ControllerLeft();
            if (object.controllerId != null)
                message.controllerId = String(object.controllerId);
            if (object.leftAtMs != null)
                if ($util.Long)
                    (message.leftAtMs = $util.Long.fromValue(object.leftAtMs)).unsigned = true;
                else if (typeof object.leftAtMs === "string")
                    message.leftAtMs = parseInt(object.leftAtMs, 10);
                else if (typeof object.leftAtMs === "number")
                    message.leftAtMs = object.leftAtMs;
                else if (typeof object.leftAtMs === "object")
                    message.leftAtMs = new $util.LongBits(object.leftAtMs.low >>> 0, object.leftAtMs.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ControllerLeft message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {nexconsole.ControllerLeft} message ControllerLeft
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ControllerLeft.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.controllerId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.leftAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.leftAtMs = options.longs === String ? "0" : 0;
            }
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                object.controllerId = message.controllerId;
            if (message.leftAtMs != null && message.hasOwnProperty("leftAtMs"))
                if (typeof message.leftAtMs === "number")
                    object.leftAtMs = options.longs === String ? String(message.leftAtMs) : message.leftAtMs;
                else
                    object.leftAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.leftAtMs) : options.longs === Number ? new $util.LongBits(message.leftAtMs.low >>> 0, message.leftAtMs.high >>> 0).toNumber(true) : message.leftAtMs;
            return object;
        };

        /**
         * Converts this ControllerLeft to JSON.
         * @function toJSON
         * @memberof nexconsole.ControllerLeft
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ControllerLeft.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ControllerLeft
         * @function getTypeUrl
         * @memberof nexconsole.ControllerLeft
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ControllerLeft.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.ControllerLeft";
        };

        return ControllerLeft;
    })();

    nexconsole.ControllerTypeAssigned = (function() {

        /**
         * Properties of a ControllerTypeAssigned.
         * @memberof nexconsole
         * @interface IControllerTypeAssigned
         * @property {string|null} [controllerId] ControllerTypeAssigned controllerId
         * @property {boolean|null} [isPrimary] ControllerTypeAssigned isPrimary
         * @property {number|null} [controllerIndex] ControllerTypeAssigned controllerIndex
         */

        /**
         * Constructs a new ControllerTypeAssigned.
         * @memberof nexconsole
         * @classdesc Represents a ControllerTypeAssigned.
         * @implements IControllerTypeAssigned
         * @constructor
         * @param {nexconsole.IControllerTypeAssigned=} [properties] Properties to set
         */
        function ControllerTypeAssigned(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ControllerTypeAssigned controllerId.
         * @member {string} controllerId
         * @memberof nexconsole.ControllerTypeAssigned
         * @instance
         */
        ControllerTypeAssigned.prototype.controllerId = "";

        /**
         * ControllerTypeAssigned isPrimary.
         * @member {boolean} isPrimary
         * @memberof nexconsole.ControllerTypeAssigned
         * @instance
         */
        ControllerTypeAssigned.prototype.isPrimary = false;

        /**
         * ControllerTypeAssigned controllerIndex.
         * @member {number} controllerIndex
         * @memberof nexconsole.ControllerTypeAssigned
         * @instance
         */
        ControllerTypeAssigned.prototype.controllerIndex = 0;

        /**
         * Creates a new ControllerTypeAssigned instance using the specified properties.
         * @function create
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {nexconsole.IControllerTypeAssigned=} [properties] Properties to set
         * @returns {nexconsole.ControllerTypeAssigned} ControllerTypeAssigned instance
         */
        ControllerTypeAssigned.create = function create(properties) {
            return new ControllerTypeAssigned(properties);
        };

        /**
         * Encodes the specified ControllerTypeAssigned message. Does not implicitly {@link nexconsole.ControllerTypeAssigned.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {nexconsole.IControllerTypeAssigned} message ControllerTypeAssigned message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerTypeAssigned.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerId != null && Object.hasOwnProperty.call(message, "controllerId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.controllerId);
            if (message.isPrimary != null && Object.hasOwnProperty.call(message, "isPrimary"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isPrimary);
            if (message.controllerIndex != null && Object.hasOwnProperty.call(message, "controllerIndex"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.controllerIndex);
            return writer;
        };

        /**
         * Encodes the specified ControllerTypeAssigned message, length delimited. Does not implicitly {@link nexconsole.ControllerTypeAssigned.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {nexconsole.IControllerTypeAssigned} message ControllerTypeAssigned message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ControllerTypeAssigned.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ControllerTypeAssigned message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.ControllerTypeAssigned} ControllerTypeAssigned
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerTypeAssigned.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.ControllerTypeAssigned();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerId = reader.string();
                        break;
                    }
                case 2: {
                        message.isPrimary = reader.bool();
                        break;
                    }
                case 3: {
                        message.controllerIndex = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ControllerTypeAssigned message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.ControllerTypeAssigned} ControllerTypeAssigned
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ControllerTypeAssigned.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ControllerTypeAssigned message.
         * @function verify
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ControllerTypeAssigned.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                if (!$util.isString(message.controllerId))
                    return "controllerId: string expected";
            if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                if (typeof message.isPrimary !== "boolean")
                    return "isPrimary: boolean expected";
            if (message.controllerIndex != null && message.hasOwnProperty("controllerIndex"))
                if (!$util.isInteger(message.controllerIndex))
                    return "controllerIndex: integer expected";
            return null;
        };

        /**
         * Creates a ControllerTypeAssigned message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.ControllerTypeAssigned} ControllerTypeAssigned
         */
        ControllerTypeAssigned.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.ControllerTypeAssigned)
                return object;
            let message = new $root.nexconsole.ControllerTypeAssigned();
            if (object.controllerId != null)
                message.controllerId = String(object.controllerId);
            if (object.isPrimary != null)
                message.isPrimary = Boolean(object.isPrimary);
            if (object.controllerIndex != null)
                message.controllerIndex = object.controllerIndex >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ControllerTypeAssigned message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {nexconsole.ControllerTypeAssigned} message ControllerTypeAssigned
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ControllerTypeAssigned.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.controllerId = "";
                object.isPrimary = false;
                object.controllerIndex = 0;
            }
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                object.controllerId = message.controllerId;
            if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                object.isPrimary = message.isPrimary;
            if (message.controllerIndex != null && message.hasOwnProperty("controllerIndex"))
                object.controllerIndex = message.controllerIndex;
            return object;
        };

        /**
         * Converts this ControllerTypeAssigned to JSON.
         * @function toJSON
         * @memberof nexconsole.ControllerTypeAssigned
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ControllerTypeAssigned.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ControllerTypeAssigned
         * @function getTypeUrl
         * @memberof nexconsole.ControllerTypeAssigned
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ControllerTypeAssigned.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.ControllerTypeAssigned";
        };

        return ControllerTypeAssigned;
    })();

    nexconsole.RelayMessage = (function() {

        /**
         * Properties of a RelayMessage.
         * @memberof nexconsole
         * @interface IRelayMessage
         * @property {nexconsole.IRoutingHeader|null} [header] RelayMessage header
         * @property {nexconsole.IMessage|null} [payload] RelayMessage payload
         */

        /**
         * Constructs a new RelayMessage.
         * @memberof nexconsole
         * @classdesc Represents a RelayMessage.
         * @implements IRelayMessage
         * @constructor
         * @param {nexconsole.IRelayMessage=} [properties] Properties to set
         */
        function RelayMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RelayMessage header.
         * @member {nexconsole.IRoutingHeader|null|undefined} header
         * @memberof nexconsole.RelayMessage
         * @instance
         */
        RelayMessage.prototype.header = null;

        /**
         * RelayMessage payload.
         * @member {nexconsole.IMessage|null|undefined} payload
         * @memberof nexconsole.RelayMessage
         * @instance
         */
        RelayMessage.prototype.payload = null;

        /**
         * Creates a new RelayMessage instance using the specified properties.
         * @function create
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {nexconsole.IRelayMessage=} [properties] Properties to set
         * @returns {nexconsole.RelayMessage} RelayMessage instance
         */
        RelayMessage.create = function create(properties) {
            return new RelayMessage(properties);
        };

        /**
         * Encodes the specified RelayMessage message. Does not implicitly {@link nexconsole.RelayMessage.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {nexconsole.IRelayMessage} message RelayMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RelayMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.header != null && Object.hasOwnProperty.call(message, "header"))
                $root.nexconsole.RoutingHeader.encode(message.header, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
                $root.nexconsole.Message.encode(message.payload, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RelayMessage message, length delimited. Does not implicitly {@link nexconsole.RelayMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {nexconsole.IRelayMessage} message RelayMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RelayMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RelayMessage message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.RelayMessage} RelayMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RelayMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.RelayMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.header = $root.nexconsole.RoutingHeader.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.payload = $root.nexconsole.Message.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RelayMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.RelayMessage} RelayMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RelayMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RelayMessage message.
         * @function verify
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RelayMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.header != null && message.hasOwnProperty("header")) {
                let error = $root.nexconsole.RoutingHeader.verify(message.header);
                if (error)
                    return "header." + error;
            }
            if (message.payload != null && message.hasOwnProperty("payload")) {
                let error = $root.nexconsole.Message.verify(message.payload);
                if (error)
                    return "payload." + error;
            }
            return null;
        };

        /**
         * Creates a RelayMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.RelayMessage} RelayMessage
         */
        RelayMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.RelayMessage)
                return object;
            let message = new $root.nexconsole.RelayMessage();
            if (object.header != null) {
                if (typeof object.header !== "object")
                    throw TypeError(".nexconsole.RelayMessage.header: object expected");
                message.header = $root.nexconsole.RoutingHeader.fromObject(object.header);
            }
            if (object.payload != null) {
                if (typeof object.payload !== "object")
                    throw TypeError(".nexconsole.RelayMessage.payload: object expected");
                message.payload = $root.nexconsole.Message.fromObject(object.payload);
            }
            return message;
        };

        /**
         * Creates a plain object from a RelayMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {nexconsole.RelayMessage} message RelayMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RelayMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.header = null;
                object.payload = null;
            }
            if (message.header != null && message.hasOwnProperty("header"))
                object.header = $root.nexconsole.RoutingHeader.toObject(message.header, options);
            if (message.payload != null && message.hasOwnProperty("payload"))
                object.payload = $root.nexconsole.Message.toObject(message.payload, options);
            return object;
        };

        /**
         * Converts this RelayMessage to JSON.
         * @function toJSON
         * @memberof nexconsole.RelayMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RelayMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RelayMessage
         * @function getTypeUrl
         * @memberof nexconsole.RelayMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RelayMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.RelayMessage";
        };

        return RelayMessage;
    })();

    nexconsole.Message = (function() {

        /**
         * Properties of a Message.
         * @memberof nexconsole
         * @interface IMessage
         * @property {nexconsole.IServerMessage|null} [serverMessage] Message serverMessage
         * @property {nexconsole.IPeerMessage|null} [peerMessage] Message peerMessage
         */

        /**
         * Constructs a new Message.
         * @memberof nexconsole
         * @classdesc Represents a Message.
         * @implements IMessage
         * @constructor
         * @param {nexconsole.IMessage=} [properties] Properties to set
         */
        function Message(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Message serverMessage.
         * @member {nexconsole.IServerMessage|null|undefined} serverMessage
         * @memberof nexconsole.Message
         * @instance
         */
        Message.prototype.serverMessage = null;

        /**
         * Message peerMessage.
         * @member {nexconsole.IPeerMessage|null|undefined} peerMessage
         * @memberof nexconsole.Message
         * @instance
         */
        Message.prototype.peerMessage = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Message messageType.
         * @member {"serverMessage"|"peerMessage"|undefined} messageType
         * @memberof nexconsole.Message
         * @instance
         */
        Object.defineProperty(Message.prototype, "messageType", {
            get: $util.oneOfGetter($oneOfFields = ["serverMessage", "peerMessage"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Message instance using the specified properties.
         * @function create
         * @memberof nexconsole.Message
         * @static
         * @param {nexconsole.IMessage=} [properties] Properties to set
         * @returns {nexconsole.Message} Message instance
         */
        Message.create = function create(properties) {
            return new Message(properties);
        };

        /**
         * Encodes the specified Message message. Does not implicitly {@link nexconsole.Message.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.Message
         * @static
         * @param {nexconsole.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.serverMessage != null && Object.hasOwnProperty.call(message, "serverMessage"))
                $root.nexconsole.ServerMessage.encode(message.serverMessage, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.peerMessage != null && Object.hasOwnProperty.call(message, "peerMessage"))
                $root.nexconsole.PeerMessage.encode(message.peerMessage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Message message, length delimited. Does not implicitly {@link nexconsole.Message.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.Message
         * @static
         * @param {nexconsole.IMessage} message Message message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Message.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Message message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.Message();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.serverMessage = $root.nexconsole.ServerMessage.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.peerMessage = $root.nexconsole.PeerMessage.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Message message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.Message
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.Message} Message
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Message.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Message message.
         * @function verify
         * @memberof nexconsole.Message
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Message.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.serverMessage != null && message.hasOwnProperty("serverMessage")) {
                properties.messageType = 1;
                {
                    let error = $root.nexconsole.ServerMessage.verify(message.serverMessage);
                    if (error)
                        return "serverMessage." + error;
                }
            }
            if (message.peerMessage != null && message.hasOwnProperty("peerMessage")) {
                if (properties.messageType === 1)
                    return "messageType: multiple values";
                properties.messageType = 1;
                {
                    let error = $root.nexconsole.PeerMessage.verify(message.peerMessage);
                    if (error)
                        return "peerMessage." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Message message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.Message
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.Message} Message
         */
        Message.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.Message)
                return object;
            let message = new $root.nexconsole.Message();
            if (object.serverMessage != null) {
                if (typeof object.serverMessage !== "object")
                    throw TypeError(".nexconsole.Message.serverMessage: object expected");
                message.serverMessage = $root.nexconsole.ServerMessage.fromObject(object.serverMessage);
            }
            if (object.peerMessage != null) {
                if (typeof object.peerMessage !== "object")
                    throw TypeError(".nexconsole.Message.peerMessage: object expected");
                message.peerMessage = $root.nexconsole.PeerMessage.fromObject(object.peerMessage);
            }
            return message;
        };

        /**
         * Creates a plain object from a Message message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.Message
         * @static
         * @param {nexconsole.Message} message Message
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Message.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.serverMessage != null && message.hasOwnProperty("serverMessage")) {
                object.serverMessage = $root.nexconsole.ServerMessage.toObject(message.serverMessage, options);
                if (options.oneofs)
                    object.messageType = "serverMessage";
            }
            if (message.peerMessage != null && message.hasOwnProperty("peerMessage")) {
                object.peerMessage = $root.nexconsole.PeerMessage.toObject(message.peerMessage, options);
                if (options.oneofs)
                    object.messageType = "peerMessage";
            }
            return object;
        };

        /**
         * Converts this Message to JSON.
         * @function toJSON
         * @memberof nexconsole.Message
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Message.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Message
         * @function getTypeUrl
         * @memberof nexconsole.Message
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.Message";
        };

        return Message;
    })();

    nexconsole.RoutingHeader = (function() {

        /**
         * Properties of a RoutingHeader.
         * @memberof nexconsole
         * @interface IRoutingHeader
         * @property {string|null} [sourceId] RoutingHeader sourceId
         * @property {nexconsole.SourceType|null} [sourceType] RoutingHeader sourceType
         * @property {string|null} [destinationId] RoutingHeader destinationId
         * @property {nexconsole.DestinationType|null} [destinationType] RoutingHeader destinationType
         * @property {string|null} [roomId] RoutingHeader roomId
         * @property {number|Long|null} [timestampMs] RoutingHeader timestampMs
         * @property {string|null} [messageId] RoutingHeader messageId
         */

        /**
         * Constructs a new RoutingHeader.
         * @memberof nexconsole
         * @classdesc Represents a RoutingHeader.
         * @implements IRoutingHeader
         * @constructor
         * @param {nexconsole.IRoutingHeader=} [properties] Properties to set
         */
        function RoutingHeader(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoutingHeader sourceId.
         * @member {string} sourceId
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.sourceId = "";

        /**
         * RoutingHeader sourceType.
         * @member {nexconsole.SourceType} sourceType
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.sourceType = 0;

        /**
         * RoutingHeader destinationId.
         * @member {string} destinationId
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.destinationId = "";

        /**
         * RoutingHeader destinationType.
         * @member {nexconsole.DestinationType} destinationType
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.destinationType = 0;

        /**
         * RoutingHeader roomId.
         * @member {string} roomId
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.roomId = "";

        /**
         * RoutingHeader timestampMs.
         * @member {number|Long} timestampMs
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.timestampMs = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * RoutingHeader messageId.
         * @member {string} messageId
         * @memberof nexconsole.RoutingHeader
         * @instance
         */
        RoutingHeader.prototype.messageId = "";

        /**
         * Creates a new RoutingHeader instance using the specified properties.
         * @function create
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {nexconsole.IRoutingHeader=} [properties] Properties to set
         * @returns {nexconsole.RoutingHeader} RoutingHeader instance
         */
        RoutingHeader.create = function create(properties) {
            return new RoutingHeader(properties);
        };

        /**
         * Encodes the specified RoutingHeader message. Does not implicitly {@link nexconsole.RoutingHeader.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {nexconsole.IRoutingHeader} message RoutingHeader message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoutingHeader.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sourceId != null && Object.hasOwnProperty.call(message, "sourceId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceId);
            if (message.sourceType != null && Object.hasOwnProperty.call(message, "sourceType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.sourceType);
            if (message.destinationId != null && Object.hasOwnProperty.call(message, "destinationId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.destinationId);
            if (message.destinationType != null && Object.hasOwnProperty.call(message, "destinationType"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.destinationType);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.roomId);
            if (message.timestampMs != null && Object.hasOwnProperty.call(message, "timestampMs"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.timestampMs);
            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.messageId);
            return writer;
        };

        /**
         * Encodes the specified RoutingHeader message, length delimited. Does not implicitly {@link nexconsole.RoutingHeader.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {nexconsole.IRoutingHeader} message RoutingHeader message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoutingHeader.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoutingHeader message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.RoutingHeader} RoutingHeader
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoutingHeader.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.RoutingHeader();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sourceId = reader.string();
                        break;
                    }
                case 2: {
                        message.sourceType = reader.int32();
                        break;
                    }
                case 3: {
                        message.destinationId = reader.string();
                        break;
                    }
                case 4: {
                        message.destinationType = reader.int32();
                        break;
                    }
                case 5: {
                        message.roomId = reader.string();
                        break;
                    }
                case 6: {
                        message.timestampMs = reader.uint64();
                        break;
                    }
                case 7: {
                        message.messageId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoutingHeader message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.RoutingHeader} RoutingHeader
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoutingHeader.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoutingHeader message.
         * @function verify
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoutingHeader.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sourceId != null && message.hasOwnProperty("sourceId"))
                if (!$util.isString(message.sourceId))
                    return "sourceId: string expected";
            if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                switch (message.sourceType) {
                default:
                    return "sourceType: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.destinationId != null && message.hasOwnProperty("destinationId"))
                if (!$util.isString(message.destinationId))
                    return "destinationId: string expected";
            if (message.destinationType != null && message.hasOwnProperty("destinationType"))
                switch (message.destinationType) {
                default:
                    return "destinationType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.timestampMs != null && message.hasOwnProperty("timestampMs"))
                if (!$util.isInteger(message.timestampMs) && !(message.timestampMs && $util.isInteger(message.timestampMs.low) && $util.isInteger(message.timestampMs.high)))
                    return "timestampMs: integer|Long expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isString(message.messageId))
                    return "messageId: string expected";
            return null;
        };

        /**
         * Creates a RoutingHeader message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.RoutingHeader} RoutingHeader
         */
        RoutingHeader.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.RoutingHeader)
                return object;
            let message = new $root.nexconsole.RoutingHeader();
            if (object.sourceId != null)
                message.sourceId = String(object.sourceId);
            switch (object.sourceType) {
            default:
                if (typeof object.sourceType === "number") {
                    message.sourceType = object.sourceType;
                    break;
                }
                break;
            case "SOURCE_TYPE_CONSOLE":
            case 0:
                message.sourceType = 0;
                break;
            case "SOURCE_TYPE_CONTROLLER":
            case 1:
                message.sourceType = 1;
                break;
            }
            if (object.destinationId != null)
                message.destinationId = String(object.destinationId);
            switch (object.destinationType) {
            default:
                if (typeof object.destinationType === "number") {
                    message.destinationType = object.destinationType;
                    break;
                }
                break;
            case "DESTINATION_TYPE_CONSOLE":
            case 0:
                message.destinationType = 0;
                break;
            case "DESTINATION_TYPE_CONTROLLER":
            case 1:
                message.destinationType = 1;
                break;
            case "DESTINATION_TYPE_BROADCAST":
            case 2:
                message.destinationType = 2;
                break;
            }
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.timestampMs != null)
                if ($util.Long)
                    (message.timestampMs = $util.Long.fromValue(object.timestampMs)).unsigned = true;
                else if (typeof object.timestampMs === "string")
                    message.timestampMs = parseInt(object.timestampMs, 10);
                else if (typeof object.timestampMs === "number")
                    message.timestampMs = object.timestampMs;
                else if (typeof object.timestampMs === "object")
                    message.timestampMs = new $util.LongBits(object.timestampMs.low >>> 0, object.timestampMs.high >>> 0).toNumber(true);
            if (object.messageId != null)
                message.messageId = String(object.messageId);
            return message;
        };

        /**
         * Creates a plain object from a RoutingHeader message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {nexconsole.RoutingHeader} message RoutingHeader
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoutingHeader.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.sourceId = "";
                object.sourceType = options.enums === String ? "SOURCE_TYPE_CONSOLE" : 0;
                object.destinationId = "";
                object.destinationType = options.enums === String ? "DESTINATION_TYPE_CONSOLE" : 0;
                object.roomId = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestampMs = options.longs === String ? "0" : 0;
                object.messageId = "";
            }
            if (message.sourceId != null && message.hasOwnProperty("sourceId"))
                object.sourceId = message.sourceId;
            if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                object.sourceType = options.enums === String ? $root.nexconsole.SourceType[message.sourceType] === undefined ? message.sourceType : $root.nexconsole.SourceType[message.sourceType] : message.sourceType;
            if (message.destinationId != null && message.hasOwnProperty("destinationId"))
                object.destinationId = message.destinationId;
            if (message.destinationType != null && message.hasOwnProperty("destinationType"))
                object.destinationType = options.enums === String ? $root.nexconsole.DestinationType[message.destinationType] === undefined ? message.destinationType : $root.nexconsole.DestinationType[message.destinationType] : message.destinationType;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.timestampMs != null && message.hasOwnProperty("timestampMs"))
                if (typeof message.timestampMs === "number")
                    object.timestampMs = options.longs === String ? String(message.timestampMs) : message.timestampMs;
                else
                    object.timestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.timestampMs) : options.longs === Number ? new $util.LongBits(message.timestampMs.low >>> 0, message.timestampMs.high >>> 0).toNumber(true) : message.timestampMs;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                object.messageId = message.messageId;
            return object;
        };

        /**
         * Converts this RoutingHeader to JSON.
         * @function toJSON
         * @memberof nexconsole.RoutingHeader
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoutingHeader.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RoutingHeader
         * @function getTypeUrl
         * @memberof nexconsole.RoutingHeader
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RoutingHeader.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.RoutingHeader";
        };

        return RoutingHeader;
    })();

    /**
     * SourceType enum.
     * @name nexconsole.SourceType
     * @enum {number}
     * @property {number} SOURCE_TYPE_CONSOLE=0 SOURCE_TYPE_CONSOLE value
     * @property {number} SOURCE_TYPE_CONTROLLER=1 SOURCE_TYPE_CONTROLLER value
     */
    nexconsole.SourceType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SOURCE_TYPE_CONSOLE"] = 0;
        values[valuesById[1] = "SOURCE_TYPE_CONTROLLER"] = 1;
        return values;
    })();

    /**
     * DestinationType enum.
     * @name nexconsole.DestinationType
     * @enum {number}
     * @property {number} DESTINATION_TYPE_CONSOLE=0 DESTINATION_TYPE_CONSOLE value
     * @property {number} DESTINATION_TYPE_CONTROLLER=1 DESTINATION_TYPE_CONTROLLER value
     * @property {number} DESTINATION_TYPE_BROADCAST=2 DESTINATION_TYPE_BROADCAST value
     */
    nexconsole.DestinationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DESTINATION_TYPE_CONSOLE"] = 0;
        values[valuesById[1] = "DESTINATION_TYPE_CONTROLLER"] = 1;
        values[valuesById[2] = "DESTINATION_TYPE_BROADCAST"] = 2;
        return values;
    })();

    nexconsole.PeerMessage = (function() {

        /**
         * Properties of a PeerMessage.
         * @memberof nexconsole
         * @interface IPeerMessage
         * @property {nexconsole.INetworkPayload|null} [networkPayload] PeerMessage networkPayload
         * @property {nexconsole.IApplicationPayload|null} [applicationPayload] PeerMessage applicationPayload
         */

        /**
         * Constructs a new PeerMessage.
         * @memberof nexconsole
         * @classdesc Represents a PeerMessage.
         * @implements IPeerMessage
         * @constructor
         * @param {nexconsole.IPeerMessage=} [properties] Properties to set
         */
        function PeerMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PeerMessage networkPayload.
         * @member {nexconsole.INetworkPayload|null|undefined} networkPayload
         * @memberof nexconsole.PeerMessage
         * @instance
         */
        PeerMessage.prototype.networkPayload = null;

        /**
         * PeerMessage applicationPayload.
         * @member {nexconsole.IApplicationPayload|null|undefined} applicationPayload
         * @memberof nexconsole.PeerMessage
         * @instance
         */
        PeerMessage.prototype.applicationPayload = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PeerMessage payload.
         * @member {"networkPayload"|"applicationPayload"|undefined} payload
         * @memberof nexconsole.PeerMessage
         * @instance
         */
        Object.defineProperty(PeerMessage.prototype, "payload", {
            get: $util.oneOfGetter($oneOfFields = ["networkPayload", "applicationPayload"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PeerMessage instance using the specified properties.
         * @function create
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {nexconsole.IPeerMessage=} [properties] Properties to set
         * @returns {nexconsole.PeerMessage} PeerMessage instance
         */
        PeerMessage.create = function create(properties) {
            return new PeerMessage(properties);
        };

        /**
         * Encodes the specified PeerMessage message. Does not implicitly {@link nexconsole.PeerMessage.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {nexconsole.IPeerMessage} message PeerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PeerMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.networkPayload != null && Object.hasOwnProperty.call(message, "networkPayload"))
                $root.nexconsole.NetworkPayload.encode(message.networkPayload, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.applicationPayload != null && Object.hasOwnProperty.call(message, "applicationPayload"))
                $root.nexconsole.ApplicationPayload.encode(message.applicationPayload, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified PeerMessage message, length delimited. Does not implicitly {@link nexconsole.PeerMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {nexconsole.IPeerMessage} message PeerMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PeerMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PeerMessage message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.PeerMessage} PeerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PeerMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.PeerMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.networkPayload = $root.nexconsole.NetworkPayload.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.applicationPayload = $root.nexconsole.ApplicationPayload.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PeerMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.PeerMessage} PeerMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PeerMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PeerMessage message.
         * @function verify
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PeerMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.networkPayload != null && message.hasOwnProperty("networkPayload")) {
                properties.payload = 1;
                {
                    let error = $root.nexconsole.NetworkPayload.verify(message.networkPayload);
                    if (error)
                        return "networkPayload." + error;
                }
            }
            if (message.applicationPayload != null && message.hasOwnProperty("applicationPayload")) {
                if (properties.payload === 1)
                    return "payload: multiple values";
                properties.payload = 1;
                {
                    let error = $root.nexconsole.ApplicationPayload.verify(message.applicationPayload);
                    if (error)
                        return "applicationPayload." + error;
                }
            }
            return null;
        };

        /**
         * Creates a PeerMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.PeerMessage} PeerMessage
         */
        PeerMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.PeerMessage)
                return object;
            let message = new $root.nexconsole.PeerMessage();
            if (object.networkPayload != null) {
                if (typeof object.networkPayload !== "object")
                    throw TypeError(".nexconsole.PeerMessage.networkPayload: object expected");
                message.networkPayload = $root.nexconsole.NetworkPayload.fromObject(object.networkPayload);
            }
            if (object.applicationPayload != null) {
                if (typeof object.applicationPayload !== "object")
                    throw TypeError(".nexconsole.PeerMessage.applicationPayload: object expected");
                message.applicationPayload = $root.nexconsole.ApplicationPayload.fromObject(object.applicationPayload);
            }
            return message;
        };

        /**
         * Creates a plain object from a PeerMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {nexconsole.PeerMessage} message PeerMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PeerMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.networkPayload != null && message.hasOwnProperty("networkPayload")) {
                object.networkPayload = $root.nexconsole.NetworkPayload.toObject(message.networkPayload, options);
                if (options.oneofs)
                    object.payload = "networkPayload";
            }
            if (message.applicationPayload != null && message.hasOwnProperty("applicationPayload")) {
                object.applicationPayload = $root.nexconsole.ApplicationPayload.toObject(message.applicationPayload, options);
                if (options.oneofs)
                    object.payload = "applicationPayload";
            }
            return object;
        };

        /**
         * Converts this PeerMessage to JSON.
         * @function toJSON
         * @memberof nexconsole.PeerMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PeerMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PeerMessage
         * @function getTypeUrl
         * @memberof nexconsole.PeerMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PeerMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.PeerMessage";
        };

        return PeerMessage;
    })();

    nexconsole.NetworkPayload = (function() {

        /**
         * Properties of a NetworkPayload.
         * @memberof nexconsole
         * @interface INetworkPayload
         * @property {nexconsole.IOffer|null} [offer] NetworkPayload offer
         * @property {nexconsole.IAnswer|null} [answer] NetworkPayload answer
         * @property {nexconsole.IIceCandidate|null} [iceCandidate] NetworkPayload iceCandidate
         */

        /**
         * Constructs a new NetworkPayload.
         * @memberof nexconsole
         * @classdesc Represents a NetworkPayload.
         * @implements INetworkPayload
         * @constructor
         * @param {nexconsole.INetworkPayload=} [properties] Properties to set
         */
        function NetworkPayload(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NetworkPayload offer.
         * @member {nexconsole.IOffer|null|undefined} offer
         * @memberof nexconsole.NetworkPayload
         * @instance
         */
        NetworkPayload.prototype.offer = null;

        /**
         * NetworkPayload answer.
         * @member {nexconsole.IAnswer|null|undefined} answer
         * @memberof nexconsole.NetworkPayload
         * @instance
         */
        NetworkPayload.prototype.answer = null;

        /**
         * NetworkPayload iceCandidate.
         * @member {nexconsole.IIceCandidate|null|undefined} iceCandidate
         * @memberof nexconsole.NetworkPayload
         * @instance
         */
        NetworkPayload.prototype.iceCandidate = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * NetworkPayload networkMessage.
         * @member {"offer"|"answer"|"iceCandidate"|undefined} networkMessage
         * @memberof nexconsole.NetworkPayload
         * @instance
         */
        Object.defineProperty(NetworkPayload.prototype, "networkMessage", {
            get: $util.oneOfGetter($oneOfFields = ["offer", "answer", "iceCandidate"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new NetworkPayload instance using the specified properties.
         * @function create
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {nexconsole.INetworkPayload=} [properties] Properties to set
         * @returns {nexconsole.NetworkPayload} NetworkPayload instance
         */
        NetworkPayload.create = function create(properties) {
            return new NetworkPayload(properties);
        };

        /**
         * Encodes the specified NetworkPayload message. Does not implicitly {@link nexconsole.NetworkPayload.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {nexconsole.INetworkPayload} message NetworkPayload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NetworkPayload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.offer != null && Object.hasOwnProperty.call(message, "offer"))
                $root.nexconsole.Offer.encode(message.offer, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.answer != null && Object.hasOwnProperty.call(message, "answer"))
                $root.nexconsole.Answer.encode(message.answer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.iceCandidate != null && Object.hasOwnProperty.call(message, "iceCandidate"))
                $root.nexconsole.IceCandidate.encode(message.iceCandidate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified NetworkPayload message, length delimited. Does not implicitly {@link nexconsole.NetworkPayload.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {nexconsole.INetworkPayload} message NetworkPayload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NetworkPayload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NetworkPayload message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.NetworkPayload} NetworkPayload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NetworkPayload.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.NetworkPayload();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.offer = $root.nexconsole.Offer.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.answer = $root.nexconsole.Answer.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.iceCandidate = $root.nexconsole.IceCandidate.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NetworkPayload message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.NetworkPayload} NetworkPayload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NetworkPayload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NetworkPayload message.
         * @function verify
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NetworkPayload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.offer != null && message.hasOwnProperty("offer")) {
                properties.networkMessage = 1;
                {
                    let error = $root.nexconsole.Offer.verify(message.offer);
                    if (error)
                        return "offer." + error;
                }
            }
            if (message.answer != null && message.hasOwnProperty("answer")) {
                if (properties.networkMessage === 1)
                    return "networkMessage: multiple values";
                properties.networkMessage = 1;
                {
                    let error = $root.nexconsole.Answer.verify(message.answer);
                    if (error)
                        return "answer." + error;
                }
            }
            if (message.iceCandidate != null && message.hasOwnProperty("iceCandidate")) {
                if (properties.networkMessage === 1)
                    return "networkMessage: multiple values";
                properties.networkMessage = 1;
                {
                    let error = $root.nexconsole.IceCandidate.verify(message.iceCandidate);
                    if (error)
                        return "iceCandidate." + error;
                }
            }
            return null;
        };

        /**
         * Creates a NetworkPayload message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.NetworkPayload} NetworkPayload
         */
        NetworkPayload.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.NetworkPayload)
                return object;
            let message = new $root.nexconsole.NetworkPayload();
            if (object.offer != null) {
                if (typeof object.offer !== "object")
                    throw TypeError(".nexconsole.NetworkPayload.offer: object expected");
                message.offer = $root.nexconsole.Offer.fromObject(object.offer);
            }
            if (object.answer != null) {
                if (typeof object.answer !== "object")
                    throw TypeError(".nexconsole.NetworkPayload.answer: object expected");
                message.answer = $root.nexconsole.Answer.fromObject(object.answer);
            }
            if (object.iceCandidate != null) {
                if (typeof object.iceCandidate !== "object")
                    throw TypeError(".nexconsole.NetworkPayload.iceCandidate: object expected");
                message.iceCandidate = $root.nexconsole.IceCandidate.fromObject(object.iceCandidate);
            }
            return message;
        };

        /**
         * Creates a plain object from a NetworkPayload message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {nexconsole.NetworkPayload} message NetworkPayload
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NetworkPayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.offer != null && message.hasOwnProperty("offer")) {
                object.offer = $root.nexconsole.Offer.toObject(message.offer, options);
                if (options.oneofs)
                    object.networkMessage = "offer";
            }
            if (message.answer != null && message.hasOwnProperty("answer")) {
                object.answer = $root.nexconsole.Answer.toObject(message.answer, options);
                if (options.oneofs)
                    object.networkMessage = "answer";
            }
            if (message.iceCandidate != null && message.hasOwnProperty("iceCandidate")) {
                object.iceCandidate = $root.nexconsole.IceCandidate.toObject(message.iceCandidate, options);
                if (options.oneofs)
                    object.networkMessage = "iceCandidate";
            }
            return object;
        };

        /**
         * Converts this NetworkPayload to JSON.
         * @function toJSON
         * @memberof nexconsole.NetworkPayload
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NetworkPayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for NetworkPayload
         * @function getTypeUrl
         * @memberof nexconsole.NetworkPayload
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        NetworkPayload.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.NetworkPayload";
        };

        return NetworkPayload;
    })();

    nexconsole.Offer = (function() {

        /**
         * Properties of an Offer.
         * @memberof nexconsole
         * @interface IOffer
         * @property {string|null} [controllerId] Offer controllerId
         * @property {string|null} [sdp] Offer sdp
         */

        /**
         * Constructs a new Offer.
         * @memberof nexconsole
         * @classdesc Represents an Offer.
         * @implements IOffer
         * @constructor
         * @param {nexconsole.IOffer=} [properties] Properties to set
         */
        function Offer(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Offer controllerId.
         * @member {string} controllerId
         * @memberof nexconsole.Offer
         * @instance
         */
        Offer.prototype.controllerId = "";

        /**
         * Offer sdp.
         * @member {string} sdp
         * @memberof nexconsole.Offer
         * @instance
         */
        Offer.prototype.sdp = "";

        /**
         * Creates a new Offer instance using the specified properties.
         * @function create
         * @memberof nexconsole.Offer
         * @static
         * @param {nexconsole.IOffer=} [properties] Properties to set
         * @returns {nexconsole.Offer} Offer instance
         */
        Offer.create = function create(properties) {
            return new Offer(properties);
        };

        /**
         * Encodes the specified Offer message. Does not implicitly {@link nexconsole.Offer.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.Offer
         * @static
         * @param {nexconsole.IOffer} message Offer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Offer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerId != null && Object.hasOwnProperty.call(message, "controllerId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.controllerId);
            if (message.sdp != null && Object.hasOwnProperty.call(message, "sdp"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sdp);
            return writer;
        };

        /**
         * Encodes the specified Offer message, length delimited. Does not implicitly {@link nexconsole.Offer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.Offer
         * @static
         * @param {nexconsole.IOffer} message Offer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Offer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Offer message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.Offer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.Offer} Offer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Offer.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.Offer();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerId = reader.string();
                        break;
                    }
                case 2: {
                        message.sdp = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Offer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.Offer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.Offer} Offer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Offer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Offer message.
         * @function verify
         * @memberof nexconsole.Offer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Offer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                if (!$util.isString(message.controllerId))
                    return "controllerId: string expected";
            if (message.sdp != null && message.hasOwnProperty("sdp"))
                if (!$util.isString(message.sdp))
                    return "sdp: string expected";
            return null;
        };

        /**
         * Creates an Offer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.Offer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.Offer} Offer
         */
        Offer.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.Offer)
                return object;
            let message = new $root.nexconsole.Offer();
            if (object.controllerId != null)
                message.controllerId = String(object.controllerId);
            if (object.sdp != null)
                message.sdp = String(object.sdp);
            return message;
        };

        /**
         * Creates a plain object from an Offer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.Offer
         * @static
         * @param {nexconsole.Offer} message Offer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Offer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.controllerId = "";
                object.sdp = "";
            }
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                object.controllerId = message.controllerId;
            if (message.sdp != null && message.hasOwnProperty("sdp"))
                object.sdp = message.sdp;
            return object;
        };

        /**
         * Converts this Offer to JSON.
         * @function toJSON
         * @memberof nexconsole.Offer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Offer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Offer
         * @function getTypeUrl
         * @memberof nexconsole.Offer
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Offer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.Offer";
        };

        return Offer;
    })();

    nexconsole.Answer = (function() {

        /**
         * Properties of an Answer.
         * @memberof nexconsole
         * @interface IAnswer
         * @property {string|null} [sdp] Answer sdp
         */

        /**
         * Constructs a new Answer.
         * @memberof nexconsole
         * @classdesc Represents an Answer.
         * @implements IAnswer
         * @constructor
         * @param {nexconsole.IAnswer=} [properties] Properties to set
         */
        function Answer(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Answer sdp.
         * @member {string} sdp
         * @memberof nexconsole.Answer
         * @instance
         */
        Answer.prototype.sdp = "";

        /**
         * Creates a new Answer instance using the specified properties.
         * @function create
         * @memberof nexconsole.Answer
         * @static
         * @param {nexconsole.IAnswer=} [properties] Properties to set
         * @returns {nexconsole.Answer} Answer instance
         */
        Answer.create = function create(properties) {
            return new Answer(properties);
        };

        /**
         * Encodes the specified Answer message. Does not implicitly {@link nexconsole.Answer.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.Answer
         * @static
         * @param {nexconsole.IAnswer} message Answer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Answer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sdp != null && Object.hasOwnProperty.call(message, "sdp"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sdp);
            return writer;
        };

        /**
         * Encodes the specified Answer message, length delimited. Does not implicitly {@link nexconsole.Answer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.Answer
         * @static
         * @param {nexconsole.IAnswer} message Answer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Answer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Answer message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.Answer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.Answer} Answer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Answer.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.Answer();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sdp = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Answer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.Answer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.Answer} Answer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Answer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Answer message.
         * @function verify
         * @memberof nexconsole.Answer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Answer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sdp != null && message.hasOwnProperty("sdp"))
                if (!$util.isString(message.sdp))
                    return "sdp: string expected";
            return null;
        };

        /**
         * Creates an Answer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.Answer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.Answer} Answer
         */
        Answer.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.Answer)
                return object;
            let message = new $root.nexconsole.Answer();
            if (object.sdp != null)
                message.sdp = String(object.sdp);
            return message;
        };

        /**
         * Creates a plain object from an Answer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.Answer
         * @static
         * @param {nexconsole.Answer} message Answer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Answer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.sdp = "";
            if (message.sdp != null && message.hasOwnProperty("sdp"))
                object.sdp = message.sdp;
            return object;
        };

        /**
         * Converts this Answer to JSON.
         * @function toJSON
         * @memberof nexconsole.Answer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Answer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Answer
         * @function getTypeUrl
         * @memberof nexconsole.Answer
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Answer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.Answer";
        };

        return Answer;
    })();

    nexconsole.IceCandidate = (function() {

        /**
         * Properties of an IceCandidate.
         * @memberof nexconsole
         * @interface IIceCandidate
         * @property {string|null} [controllerId] IceCandidate controllerId
         * @property {string|null} [candidate] IceCandidate candidate
         * @property {string|null} [sdpMid] IceCandidate sdpMid
         * @property {number|null} [sdpMlineIndex] IceCandidate sdpMlineIndex
         * @property {string|null} [usernameFragment] IceCandidate usernameFragment
         */

        /**
         * Constructs a new IceCandidate.
         * @memberof nexconsole
         * @classdesc Represents an IceCandidate.
         * @implements IIceCandidate
         * @constructor
         * @param {nexconsole.IIceCandidate=} [properties] Properties to set
         */
        function IceCandidate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IceCandidate controllerId.
         * @member {string} controllerId
         * @memberof nexconsole.IceCandidate
         * @instance
         */
        IceCandidate.prototype.controllerId = "";

        /**
         * IceCandidate candidate.
         * @member {string} candidate
         * @memberof nexconsole.IceCandidate
         * @instance
         */
        IceCandidate.prototype.candidate = "";

        /**
         * IceCandidate sdpMid.
         * @member {string} sdpMid
         * @memberof nexconsole.IceCandidate
         * @instance
         */
        IceCandidate.prototype.sdpMid = "";

        /**
         * IceCandidate sdpMlineIndex.
         * @member {number} sdpMlineIndex
         * @memberof nexconsole.IceCandidate
         * @instance
         */
        IceCandidate.prototype.sdpMlineIndex = 0;

        /**
         * IceCandidate usernameFragment.
         * @member {string} usernameFragment
         * @memberof nexconsole.IceCandidate
         * @instance
         */
        IceCandidate.prototype.usernameFragment = "";

        /**
         * Creates a new IceCandidate instance using the specified properties.
         * @function create
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {nexconsole.IIceCandidate=} [properties] Properties to set
         * @returns {nexconsole.IceCandidate} IceCandidate instance
         */
        IceCandidate.create = function create(properties) {
            return new IceCandidate(properties);
        };

        /**
         * Encodes the specified IceCandidate message. Does not implicitly {@link nexconsole.IceCandidate.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {nexconsole.IIceCandidate} message IceCandidate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IceCandidate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerId != null && Object.hasOwnProperty.call(message, "controllerId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.controllerId);
            if (message.candidate != null && Object.hasOwnProperty.call(message, "candidate"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.candidate);
            if (message.sdpMid != null && Object.hasOwnProperty.call(message, "sdpMid"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.sdpMid);
            if (message.sdpMlineIndex != null && Object.hasOwnProperty.call(message, "sdpMlineIndex"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sdpMlineIndex);
            if (message.usernameFragment != null && Object.hasOwnProperty.call(message, "usernameFragment"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.usernameFragment);
            return writer;
        };

        /**
         * Encodes the specified IceCandidate message, length delimited. Does not implicitly {@link nexconsole.IceCandidate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {nexconsole.IIceCandidate} message IceCandidate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IceCandidate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IceCandidate message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.IceCandidate} IceCandidate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IceCandidate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.IceCandidate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.controllerId = reader.string();
                        break;
                    }
                case 2: {
                        message.candidate = reader.string();
                        break;
                    }
                case 3: {
                        message.sdpMid = reader.string();
                        break;
                    }
                case 4: {
                        message.sdpMlineIndex = reader.int32();
                        break;
                    }
                case 5: {
                        message.usernameFragment = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IceCandidate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.IceCandidate} IceCandidate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IceCandidate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IceCandidate message.
         * @function verify
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IceCandidate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                if (!$util.isString(message.controllerId))
                    return "controllerId: string expected";
            if (message.candidate != null && message.hasOwnProperty("candidate"))
                if (!$util.isString(message.candidate))
                    return "candidate: string expected";
            if (message.sdpMid != null && message.hasOwnProperty("sdpMid"))
                if (!$util.isString(message.sdpMid))
                    return "sdpMid: string expected";
            if (message.sdpMlineIndex != null && message.hasOwnProperty("sdpMlineIndex"))
                if (!$util.isInteger(message.sdpMlineIndex))
                    return "sdpMlineIndex: integer expected";
            if (message.usernameFragment != null && message.hasOwnProperty("usernameFragment"))
                if (!$util.isString(message.usernameFragment))
                    return "usernameFragment: string expected";
            return null;
        };

        /**
         * Creates an IceCandidate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.IceCandidate} IceCandidate
         */
        IceCandidate.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.IceCandidate)
                return object;
            let message = new $root.nexconsole.IceCandidate();
            if (object.controllerId != null)
                message.controllerId = String(object.controllerId);
            if (object.candidate != null)
                message.candidate = String(object.candidate);
            if (object.sdpMid != null)
                message.sdpMid = String(object.sdpMid);
            if (object.sdpMlineIndex != null)
                message.sdpMlineIndex = object.sdpMlineIndex | 0;
            if (object.usernameFragment != null)
                message.usernameFragment = String(object.usernameFragment);
            return message;
        };

        /**
         * Creates a plain object from an IceCandidate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {nexconsole.IceCandidate} message IceCandidate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IceCandidate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.controllerId = "";
                object.candidate = "";
                object.sdpMid = "";
                object.sdpMlineIndex = 0;
                object.usernameFragment = "";
            }
            if (message.controllerId != null && message.hasOwnProperty("controllerId"))
                object.controllerId = message.controllerId;
            if (message.candidate != null && message.hasOwnProperty("candidate"))
                object.candidate = message.candidate;
            if (message.sdpMid != null && message.hasOwnProperty("sdpMid"))
                object.sdpMid = message.sdpMid;
            if (message.sdpMlineIndex != null && message.hasOwnProperty("sdpMlineIndex"))
                object.sdpMlineIndex = message.sdpMlineIndex;
            if (message.usernameFragment != null && message.hasOwnProperty("usernameFragment"))
                object.usernameFragment = message.usernameFragment;
            return object;
        };

        /**
         * Converts this IceCandidate to JSON.
         * @function toJSON
         * @memberof nexconsole.IceCandidate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IceCandidate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IceCandidate
         * @function getTypeUrl
         * @memberof nexconsole.IceCandidate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IceCandidate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.IceCandidate";
        };

        return IceCandidate;
    })();

    nexconsole.ApplicationPayload = (function() {

        /**
         * Properties of an ApplicationPayload.
         * @memberof nexconsole
         * @interface IApplicationPayload
         * @property {nexconsole.IRoomReady|null} [roomReady] ApplicationPayload roomReady
         * @property {nexconsole.IGameStart|null} [gameStart] ApplicationPayload gameStart
         * @property {nexconsole.IMenuAction|null} [menuAction] ApplicationPayload menuAction
         * @property {nexconsole.IOrientationData|null} [orientationData] ApplicationPayload orientationData
         * @property {nexconsole.IGameAction|null} [gameAction] ApplicationPayload gameAction
         */

        /**
         * Constructs a new ApplicationPayload.
         * @memberof nexconsole
         * @classdesc Represents an ApplicationPayload.
         * @implements IApplicationPayload
         * @constructor
         * @param {nexconsole.IApplicationPayload=} [properties] Properties to set
         */
        function ApplicationPayload(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ApplicationPayload roomReady.
         * @member {nexconsole.IRoomReady|null|undefined} roomReady
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        ApplicationPayload.prototype.roomReady = null;

        /**
         * ApplicationPayload gameStart.
         * @member {nexconsole.IGameStart|null|undefined} gameStart
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        ApplicationPayload.prototype.gameStart = null;

        /**
         * ApplicationPayload menuAction.
         * @member {nexconsole.IMenuAction|null|undefined} menuAction
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        ApplicationPayload.prototype.menuAction = null;

        /**
         * ApplicationPayload orientationData.
         * @member {nexconsole.IOrientationData|null|undefined} orientationData
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        ApplicationPayload.prototype.orientationData = null;

        /**
         * ApplicationPayload gameAction.
         * @member {nexconsole.IGameAction|null|undefined} gameAction
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        ApplicationPayload.prototype.gameAction = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ApplicationPayload appMessage.
         * @member {"roomReady"|"gameStart"|"menuAction"|"orientationData"|"gameAction"|undefined} appMessage
         * @memberof nexconsole.ApplicationPayload
         * @instance
         */
        Object.defineProperty(ApplicationPayload.prototype, "appMessage", {
            get: $util.oneOfGetter($oneOfFields = ["roomReady", "gameStart", "menuAction", "orientationData", "gameAction"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ApplicationPayload instance using the specified properties.
         * @function create
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {nexconsole.IApplicationPayload=} [properties] Properties to set
         * @returns {nexconsole.ApplicationPayload} ApplicationPayload instance
         */
        ApplicationPayload.create = function create(properties) {
            return new ApplicationPayload(properties);
        };

        /**
         * Encodes the specified ApplicationPayload message. Does not implicitly {@link nexconsole.ApplicationPayload.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {nexconsole.IApplicationPayload} message ApplicationPayload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplicationPayload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomReady != null && Object.hasOwnProperty.call(message, "roomReady"))
                $root.nexconsole.RoomReady.encode(message.roomReady, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.gameStart != null && Object.hasOwnProperty.call(message, "gameStart"))
                $root.nexconsole.GameStart.encode(message.gameStart, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.menuAction != null && Object.hasOwnProperty.call(message, "menuAction"))
                $root.nexconsole.MenuAction.encode(message.menuAction, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.orientationData != null && Object.hasOwnProperty.call(message, "orientationData"))
                $root.nexconsole.OrientationData.encode(message.orientationData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.gameAction != null && Object.hasOwnProperty.call(message, "gameAction"))
                $root.nexconsole.GameAction.encode(message.gameAction, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ApplicationPayload message, length delimited. Does not implicitly {@link nexconsole.ApplicationPayload.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {nexconsole.IApplicationPayload} message ApplicationPayload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplicationPayload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ApplicationPayload message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.ApplicationPayload} ApplicationPayload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplicationPayload.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.ApplicationPayload();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.roomReady = $root.nexconsole.RoomReady.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.gameStart = $root.nexconsole.GameStart.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.menuAction = $root.nexconsole.MenuAction.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.orientationData = $root.nexconsole.OrientationData.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.gameAction = $root.nexconsole.GameAction.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ApplicationPayload message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.ApplicationPayload} ApplicationPayload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplicationPayload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ApplicationPayload message.
         * @function verify
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ApplicationPayload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.roomReady != null && message.hasOwnProperty("roomReady")) {
                properties.appMessage = 1;
                {
                    let error = $root.nexconsole.RoomReady.verify(message.roomReady);
                    if (error)
                        return "roomReady." + error;
                }
            }
            if (message.gameStart != null && message.hasOwnProperty("gameStart")) {
                if (properties.appMessage === 1)
                    return "appMessage: multiple values";
                properties.appMessage = 1;
                {
                    let error = $root.nexconsole.GameStart.verify(message.gameStart);
                    if (error)
                        return "gameStart." + error;
                }
            }
            if (message.menuAction != null && message.hasOwnProperty("menuAction")) {
                if (properties.appMessage === 1)
                    return "appMessage: multiple values";
                properties.appMessage = 1;
                {
                    let error = $root.nexconsole.MenuAction.verify(message.menuAction);
                    if (error)
                        return "menuAction." + error;
                }
            }
            if (message.orientationData != null && message.hasOwnProperty("orientationData")) {
                if (properties.appMessage === 1)
                    return "appMessage: multiple values";
                properties.appMessage = 1;
                {
                    let error = $root.nexconsole.OrientationData.verify(message.orientationData);
                    if (error)
                        return "orientationData." + error;
                }
            }
            if (message.gameAction != null && message.hasOwnProperty("gameAction")) {
                if (properties.appMessage === 1)
                    return "appMessage: multiple values";
                properties.appMessage = 1;
                {
                    let error = $root.nexconsole.GameAction.verify(message.gameAction);
                    if (error)
                        return "gameAction." + error;
                }
            }
            return null;
        };

        /**
         * Creates an ApplicationPayload message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.ApplicationPayload} ApplicationPayload
         */
        ApplicationPayload.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.ApplicationPayload)
                return object;
            let message = new $root.nexconsole.ApplicationPayload();
            if (object.roomReady != null) {
                if (typeof object.roomReady !== "object")
                    throw TypeError(".nexconsole.ApplicationPayload.roomReady: object expected");
                message.roomReady = $root.nexconsole.RoomReady.fromObject(object.roomReady);
            }
            if (object.gameStart != null) {
                if (typeof object.gameStart !== "object")
                    throw TypeError(".nexconsole.ApplicationPayload.gameStart: object expected");
                message.gameStart = $root.nexconsole.GameStart.fromObject(object.gameStart);
            }
            if (object.menuAction != null) {
                if (typeof object.menuAction !== "object")
                    throw TypeError(".nexconsole.ApplicationPayload.menuAction: object expected");
                message.menuAction = $root.nexconsole.MenuAction.fromObject(object.menuAction);
            }
            if (object.orientationData != null) {
                if (typeof object.orientationData !== "object")
                    throw TypeError(".nexconsole.ApplicationPayload.orientationData: object expected");
                message.orientationData = $root.nexconsole.OrientationData.fromObject(object.orientationData);
            }
            if (object.gameAction != null) {
                if (typeof object.gameAction !== "object")
                    throw TypeError(".nexconsole.ApplicationPayload.gameAction: object expected");
                message.gameAction = $root.nexconsole.GameAction.fromObject(object.gameAction);
            }
            return message;
        };

        /**
         * Creates a plain object from an ApplicationPayload message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {nexconsole.ApplicationPayload} message ApplicationPayload
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ApplicationPayload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.roomReady != null && message.hasOwnProperty("roomReady")) {
                object.roomReady = $root.nexconsole.RoomReady.toObject(message.roomReady, options);
                if (options.oneofs)
                    object.appMessage = "roomReady";
            }
            if (message.gameStart != null && message.hasOwnProperty("gameStart")) {
                object.gameStart = $root.nexconsole.GameStart.toObject(message.gameStart, options);
                if (options.oneofs)
                    object.appMessage = "gameStart";
            }
            if (message.menuAction != null && message.hasOwnProperty("menuAction")) {
                object.menuAction = $root.nexconsole.MenuAction.toObject(message.menuAction, options);
                if (options.oneofs)
                    object.appMessage = "menuAction";
            }
            if (message.orientationData != null && message.hasOwnProperty("orientationData")) {
                object.orientationData = $root.nexconsole.OrientationData.toObject(message.orientationData, options);
                if (options.oneofs)
                    object.appMessage = "orientationData";
            }
            if (message.gameAction != null && message.hasOwnProperty("gameAction")) {
                object.gameAction = $root.nexconsole.GameAction.toObject(message.gameAction, options);
                if (options.oneofs)
                    object.appMessage = "gameAction";
            }
            return object;
        };

        /**
         * Converts this ApplicationPayload to JSON.
         * @function toJSON
         * @memberof nexconsole.ApplicationPayload
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ApplicationPayload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ApplicationPayload
         * @function getTypeUrl
         * @memberof nexconsole.ApplicationPayload
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ApplicationPayload.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.ApplicationPayload";
        };

        return ApplicationPayload;
    })();

    nexconsole.RoomReady = (function() {

        /**
         * Properties of a RoomReady.
         * @memberof nexconsole
         * @interface IRoomReady
         */

        /**
         * Constructs a new RoomReady.
         * @memberof nexconsole
         * @classdesc Represents a RoomReady.
         * @implements IRoomReady
         * @constructor
         * @param {nexconsole.IRoomReady=} [properties] Properties to set
         */
        function RoomReady(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RoomReady instance using the specified properties.
         * @function create
         * @memberof nexconsole.RoomReady
         * @static
         * @param {nexconsole.IRoomReady=} [properties] Properties to set
         * @returns {nexconsole.RoomReady} RoomReady instance
         */
        RoomReady.create = function create(properties) {
            return new RoomReady(properties);
        };

        /**
         * Encodes the specified RoomReady message. Does not implicitly {@link nexconsole.RoomReady.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.RoomReady
         * @static
         * @param {nexconsole.IRoomReady} message RoomReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomReady.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified RoomReady message, length delimited. Does not implicitly {@link nexconsole.RoomReady.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.RoomReady
         * @static
         * @param {nexconsole.IRoomReady} message RoomReady message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomReady.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomReady message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.RoomReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.RoomReady} RoomReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomReady.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.RoomReady();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomReady message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.RoomReady
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.RoomReady} RoomReady
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomReady.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomReady message.
         * @function verify
         * @memberof nexconsole.RoomReady
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomReady.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a RoomReady message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.RoomReady
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.RoomReady} RoomReady
         */
        RoomReady.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.RoomReady)
                return object;
            return new $root.nexconsole.RoomReady();
        };

        /**
         * Creates a plain object from a RoomReady message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.RoomReady
         * @static
         * @param {nexconsole.RoomReady} message RoomReady
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomReady.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RoomReady to JSON.
         * @function toJSON
         * @memberof nexconsole.RoomReady
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomReady.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RoomReady
         * @function getTypeUrl
         * @memberof nexconsole.RoomReady
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RoomReady.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.RoomReady";
        };

        return RoomReady;
    })();

    nexconsole.GameStart = (function() {

        /**
         * Properties of a GameStart.
         * @memberof nexconsole
         * @interface IGameStart
         * @property {string|null} [controllerUrl] GameStart controllerUrl
         */

        /**
         * Constructs a new GameStart.
         * @memberof nexconsole
         * @classdesc Represents a GameStart.
         * @implements IGameStart
         * @constructor
         * @param {nexconsole.IGameStart=} [properties] Properties to set
         */
        function GameStart(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameStart controllerUrl.
         * @member {string} controllerUrl
         * @memberof nexconsole.GameStart
         * @instance
         */
        GameStart.prototype.controllerUrl = "";

        /**
         * Creates a new GameStart instance using the specified properties.
         * @function create
         * @memberof nexconsole.GameStart
         * @static
         * @param {nexconsole.IGameStart=} [properties] Properties to set
         * @returns {nexconsole.GameStart} GameStart instance
         */
        GameStart.create = function create(properties) {
            return new GameStart(properties);
        };

        /**
         * Encodes the specified GameStart message. Does not implicitly {@link nexconsole.GameStart.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.GameStart
         * @static
         * @param {nexconsole.IGameStart} message GameStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameStart.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.controllerUrl != null && Object.hasOwnProperty.call(message, "controllerUrl"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.controllerUrl);
            return writer;
        };

        /**
         * Encodes the specified GameStart message, length delimited. Does not implicitly {@link nexconsole.GameStart.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.GameStart
         * @static
         * @param {nexconsole.IGameStart} message GameStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameStart.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameStart message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.GameStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.GameStart} GameStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameStart.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.GameStart();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.controllerUrl = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameStart message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.GameStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.GameStart} GameStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameStart.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameStart message.
         * @function verify
         * @memberof nexconsole.GameStart
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameStart.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.controllerUrl != null && message.hasOwnProperty("controllerUrl"))
                if (!$util.isString(message.controllerUrl))
                    return "controllerUrl: string expected";
            return null;
        };

        /**
         * Creates a GameStart message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.GameStart
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.GameStart} GameStart
         */
        GameStart.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.GameStart)
                return object;
            let message = new $root.nexconsole.GameStart();
            if (object.controllerUrl != null)
                message.controllerUrl = String(object.controllerUrl);
            return message;
        };

        /**
         * Creates a plain object from a GameStart message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.GameStart
         * @static
         * @param {nexconsole.GameStart} message GameStart
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameStart.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.controllerUrl = "";
            if (message.controllerUrl != null && message.hasOwnProperty("controllerUrl"))
                object.controllerUrl = message.controllerUrl;
            return object;
        };

        /**
         * Converts this GameStart to JSON.
         * @function toJSON
         * @memberof nexconsole.GameStart
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameStart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GameStart
         * @function getTypeUrl
         * @memberof nexconsole.GameStart
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GameStart.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.GameStart";
        };

        return GameStart;
    })();

    nexconsole.GameAction = (function() {

        /**
         * Properties of a GameAction.
         * @memberof nexconsole
         * @interface IGameAction
         * @property {string|null} [action] GameAction action
         */

        /**
         * Constructs a new GameAction.
         * @memberof nexconsole
         * @classdesc Represents a GameAction.
         * @implements IGameAction
         * @constructor
         * @param {nexconsole.IGameAction=} [properties] Properties to set
         */
        function GameAction(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameAction action.
         * @member {string} action
         * @memberof nexconsole.GameAction
         * @instance
         */
        GameAction.prototype.action = "";

        /**
         * Creates a new GameAction instance using the specified properties.
         * @function create
         * @memberof nexconsole.GameAction
         * @static
         * @param {nexconsole.IGameAction=} [properties] Properties to set
         * @returns {nexconsole.GameAction} GameAction instance
         */
        GameAction.create = function create(properties) {
            return new GameAction(properties);
        };

        /**
         * Encodes the specified GameAction message. Does not implicitly {@link nexconsole.GameAction.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.GameAction
         * @static
         * @param {nexconsole.IGameAction} message GameAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.action);
            return writer;
        };

        /**
         * Encodes the specified GameAction message, length delimited. Does not implicitly {@link nexconsole.GameAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.GameAction
         * @static
         * @param {nexconsole.IGameAction} message GameAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameAction message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.GameAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.GameAction} GameAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameAction.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.GameAction();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.action = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.GameAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.GameAction} GameAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameAction message.
         * @function verify
         * @memberof nexconsole.GameAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.action != null && message.hasOwnProperty("action"))
                if (!$util.isString(message.action))
                    return "action: string expected";
            return null;
        };

        /**
         * Creates a GameAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.GameAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.GameAction} GameAction
         */
        GameAction.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.GameAction)
                return object;
            let message = new $root.nexconsole.GameAction();
            if (object.action != null)
                message.action = String(object.action);
            return message;
        };

        /**
         * Creates a plain object from a GameAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.GameAction
         * @static
         * @param {nexconsole.GameAction} message GameAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.action = "";
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = message.action;
            return object;
        };

        /**
         * Converts this GameAction to JSON.
         * @function toJSON
         * @memberof nexconsole.GameAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GameAction
         * @function getTypeUrl
         * @memberof nexconsole.GameAction
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GameAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.GameAction";
        };

        return GameAction;
    })();

    nexconsole.OrientationData = (function() {

        /**
         * Properties of an OrientationData.
         * @memberof nexconsole
         * @interface IOrientationData
         * @property {number|null} [pitch] OrientationData pitch
         */

        /**
         * Constructs a new OrientationData.
         * @memberof nexconsole
         * @classdesc Represents an OrientationData.
         * @implements IOrientationData
         * @constructor
         * @param {nexconsole.IOrientationData=} [properties] Properties to set
         */
        function OrientationData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OrientationData pitch.
         * @member {number} pitch
         * @memberof nexconsole.OrientationData
         * @instance
         */
        OrientationData.prototype.pitch = 0;

        /**
         * Creates a new OrientationData instance using the specified properties.
         * @function create
         * @memberof nexconsole.OrientationData
         * @static
         * @param {nexconsole.IOrientationData=} [properties] Properties to set
         * @returns {nexconsole.OrientationData} OrientationData instance
         */
        OrientationData.create = function create(properties) {
            return new OrientationData(properties);
        };

        /**
         * Encodes the specified OrientationData message. Does not implicitly {@link nexconsole.OrientationData.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.OrientationData
         * @static
         * @param {nexconsole.IOrientationData} message OrientationData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrientationData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pitch != null && Object.hasOwnProperty.call(message, "pitch"))
                writer.uint32(/* id 1, wireType 5 =*/13).float(message.pitch);
            return writer;
        };

        /**
         * Encodes the specified OrientationData message, length delimited. Does not implicitly {@link nexconsole.OrientationData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.OrientationData
         * @static
         * @param {nexconsole.IOrientationData} message OrientationData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrientationData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OrientationData message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.OrientationData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.OrientationData} OrientationData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrientationData.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.OrientationData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pitch = reader.float();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OrientationData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.OrientationData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.OrientationData} OrientationData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrientationData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OrientationData message.
         * @function verify
         * @memberof nexconsole.OrientationData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OrientationData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pitch != null && message.hasOwnProperty("pitch"))
                if (typeof message.pitch !== "number")
                    return "pitch: number expected";
            return null;
        };

        /**
         * Creates an OrientationData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.OrientationData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.OrientationData} OrientationData
         */
        OrientationData.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.OrientationData)
                return object;
            let message = new $root.nexconsole.OrientationData();
            if (object.pitch != null)
                message.pitch = Number(object.pitch);
            return message;
        };

        /**
         * Creates a plain object from an OrientationData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.OrientationData
         * @static
         * @param {nexconsole.OrientationData} message OrientationData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OrientationData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.pitch = 0;
            if (message.pitch != null && message.hasOwnProperty("pitch"))
                object.pitch = options.json && !isFinite(message.pitch) ? String(message.pitch) : message.pitch;
            return object;
        };

        /**
         * Converts this OrientationData to JSON.
         * @function toJSON
         * @memberof nexconsole.OrientationData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OrientationData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OrientationData
         * @function getTypeUrl
         * @memberof nexconsole.OrientationData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OrientationData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.OrientationData";
        };

        return OrientationData;
    })();

    nexconsole.MenuAction = (function() {

        /**
         * Properties of a MenuAction.
         * @memberof nexconsole
         * @interface IMenuAction
         * @property {nexconsole.MenuAction.MenuButton|null} [button] MenuAction button
         */

        /**
         * Constructs a new MenuAction.
         * @memberof nexconsole
         * @classdesc Represents a MenuAction.
         * @implements IMenuAction
         * @constructor
         * @param {nexconsole.IMenuAction=} [properties] Properties to set
         */
        function MenuAction(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MenuAction button.
         * @member {nexconsole.MenuAction.MenuButton} button
         * @memberof nexconsole.MenuAction
         * @instance
         */
        MenuAction.prototype.button = 1;

        /**
         * Creates a new MenuAction instance using the specified properties.
         * @function create
         * @memberof nexconsole.MenuAction
         * @static
         * @param {nexconsole.IMenuAction=} [properties] Properties to set
         * @returns {nexconsole.MenuAction} MenuAction instance
         */
        MenuAction.create = function create(properties) {
            return new MenuAction(properties);
        };

        /**
         * Encodes the specified MenuAction message. Does not implicitly {@link nexconsole.MenuAction.verify|verify} messages.
         * @function encode
         * @memberof nexconsole.MenuAction
         * @static
         * @param {nexconsole.IMenuAction} message MenuAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MenuAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.button != null && Object.hasOwnProperty.call(message, "button"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.button);
            return writer;
        };

        /**
         * Encodes the specified MenuAction message, length delimited. Does not implicitly {@link nexconsole.MenuAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof nexconsole.MenuAction
         * @static
         * @param {nexconsole.IMenuAction} message MenuAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MenuAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MenuAction message from the specified reader or buffer.
         * @function decode
         * @memberof nexconsole.MenuAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {nexconsole.MenuAction} MenuAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MenuAction.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.nexconsole.MenuAction();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.button = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MenuAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof nexconsole.MenuAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {nexconsole.MenuAction} MenuAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MenuAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MenuAction message.
         * @function verify
         * @memberof nexconsole.MenuAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MenuAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.button != null && message.hasOwnProperty("button"))
                switch (message.button) {
                default:
                    return "button: enum value expected";
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            return null;
        };

        /**
         * Creates a MenuAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof nexconsole.MenuAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {nexconsole.MenuAction} MenuAction
         */
        MenuAction.fromObject = function fromObject(object) {
            if (object instanceof $root.nexconsole.MenuAction)
                return object;
            let message = new $root.nexconsole.MenuAction();
            switch (object.button) {
            default:
                if (typeof object.button === "number") {
                    message.button = object.button;
                    break;
                }
                break;
            case "MENU_UP":
            case 1:
                message.button = 1;
                break;
            case "MENU_DOWN":
            case 2:
                message.button = 2;
                break;
            case "MENU_LEFT":
            case 3:
                message.button = 3;
                break;
            case "MENU_RIGHT":
            case 4:
                message.button = 4;
                break;
            case "MENU_SELECT":
            case 5:
                message.button = 5;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a MenuAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof nexconsole.MenuAction
         * @static
         * @param {nexconsole.MenuAction} message MenuAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MenuAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.button = options.enums === String ? "MENU_UP" : 1;
            if (message.button != null && message.hasOwnProperty("button"))
                object.button = options.enums === String ? $root.nexconsole.MenuAction.MenuButton[message.button] === undefined ? message.button : $root.nexconsole.MenuAction.MenuButton[message.button] : message.button;
            return object;
        };

        /**
         * Converts this MenuAction to JSON.
         * @function toJSON
         * @memberof nexconsole.MenuAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MenuAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MenuAction
         * @function getTypeUrl
         * @memberof nexconsole.MenuAction
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MenuAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/nexconsole.MenuAction";
        };

        /**
         * MenuButton enum.
         * @name nexconsole.MenuAction.MenuButton
         * @enum {number}
         * @property {number} MENU_UP=1 MENU_UP value
         * @property {number} MENU_DOWN=2 MENU_DOWN value
         * @property {number} MENU_LEFT=3 MENU_LEFT value
         * @property {number} MENU_RIGHT=4 MENU_RIGHT value
         * @property {number} MENU_SELECT=5 MENU_SELECT value
         */
        MenuAction.MenuButton = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[1] = "MENU_UP"] = 1;
            values[valuesById[2] = "MENU_DOWN"] = 2;
            values[valuesById[3] = "MENU_LEFT"] = 3;
            values[valuesById[4] = "MENU_RIGHT"] = 4;
            values[valuesById[5] = "MENU_SELECT"] = 5;
            return values;
        })();

        return MenuAction;
    })();

    return nexconsole;
})();

export { $root as default };
